module.exports = __webpack_public_path__ + "img/medium.8cccf4c1.svg";